<template>
  <LoadingWrapper :loading="loading" dir="rtl">
    <FloatingBarComponent v-if="floatingBarData" :content="floatingBarData.form" />
    <div class="row mw1180 dmargin-top-50 header-shadow">
      <div class="col-12 col-xl-7 p-0" style="position: relative">
        <!-- ; margin: 30px 0 -->
        <SectionImageComponent :image="$responsive(data.cook.pictures.atmosphere_picture)" />
        <LikeComponent position="top-right" v-if="data.cook.likes" :likes="data.cook.likes" @click.stop="false" />
        <RatingComponent class="pointer position-absolute" :rating="data.cook.rating_preview" @click="scrollToRating" style="top: 15px; left: 20px; background-color:rgba(255,255,255,0.7); border-radius: 10px; padding-left:5px; padding-right:5px;" />
        <CookHeadComponent v-if="data.cook.pictures.cartoon_picture" :image="$responsive(data.cook.pictures.cartoon_picture)" variant="cookheader" />
        <YummiExtraComponent v-if="data.cook.yummi_extra" :image="$responsive(data.cook.yummi_extra.image)" :popup_data="data.cook.yummi_extra.popup_data" variant="cookheader"/>
        <CookChoiceBadgeComponent :badgeImage="$responsive(data.cook.pictures.badge)" v-if="data.cook.pictures.badge" variant="cook-view" />
      </div>
      <div class="col-12 col-xl-5">
        <div class="mw360 margin-top-20 dmargin-top-50">
          <div class="f22-l23-sb df36-l30-b" v-html="data.cook.main_title_html" />
          <div class="f14-l17 df16-l20 red text-break two-lines-on-carousel" v-html="data.cook.subtitle_html"></div>
          <div class="f14-l17 df16-l20 bold text-break two-lines-on-carousel" v-html="data.cook.time_on_site" v-if="data.cook.time_on_site"></div>
          <div v-if="data.cook.personal_info.recycler" class="recycler_container">
            <img :src="data.cook.personal_info.recycler_data.icon" class="recycler_image" />
            <div class="f14-l17 df16-l20 bold recycler_text_container" >{{ data.cook.personal_info.recycler_data.recycler_text }}</div>
          </div>

          <div class="f14-l18 df16-l20 margin-top-10">
            <ReadMore :text="data.cook.personal_info.about.html" :moreText="data.cook.personal_info.about.read_more_text" />
          </div>
           
        </div>
      </div>
    </div>
    <CookAttributesComponent :initialData="data.cook" :updateUrl="data.cook.attributes_fetch_url" />
    <div class="row dmargin-lr-0">
      <DishTypeFilterComponent :categories="categoryList" :barInfo="data.cook.categories_bar" class="user-select-none" />
    </div>
    <div class="row position-relative dmargin-lr-0  ">
      <StickyElement :desktopOffset="156" :mobileOffset="50" class="p-0">
        <form :action="data.cook.filters.form.submit.href" ref="form" :method="data.cook.filters.form.submit.method" class="bg-d9">
          <div class="d-flex flex-row justify-content-center align-items-center f14-l23 df18-l23 py-1" >
            <div class="flex-fill"></div>
            <div
              v-if="data.chat"
              class="ai_frame px-1 justify-content-center align-items-center"
              :class="{ pointer: !wsEnabled, disabled: wsEnabled }"
              v-html="data.chat.label"
              @click="!wsEnabled && openWizard()"
              :aria-disabled="wsEnabled"
              :tabindex="wsEnabled ? -1 : 0"
            ></div>
            <div v-if="data.cook.filters.head" @click="openPopup(data.cook.filters.head.popup_content)" style="margin-top: 3px;"  class="pointer px-1 " v-html="data.cook.filters.head.title"></div>
            <FormFilterTagsComponent v-for="(field,fidx) in data.cook.filters.form.fields" :key="`field_${fidx}`" :field="field" @change="submitFilter" class="px-1 " style="margin-top: 3px;" />
            <div class="flex-fill"></div>
          </div>
        </form>

        <div v-if="filterListDisplay" class="d-flex bg-white flex-row f14-l23 df18-l23" style="margin-right: 56px">
          <div class="flex-fill"></div>
          <div class="bold">{{filterListDisplay.label}}</div>
          <div class="px-1" v-html="filterListDisplay.text_html"></div>
          <div class="flex-fill"></div>
        </div>
      </StickyElement>
    </div>
    <div class="row dmargin-lr-0" ref="list">
      <!-- <HorizontalScrollContainer class="preferences">
        <DishFilterComponent v-for="p in data.cook.dishes_filter_tags" :item="p" :key="p" @click="addRemoveFilter(p.search_val)" class="pointer" />
      </HorizontalScrollContainer> -->

      <LoadingWrapper v-show="innerLoading" :loading="innerLoading" style="position:fixed; top:0; left:0;width:100%; height:100%; z-index:10000;" clz="center"></LoadingWrapper>
      <CategoryAndDishesComponent v-for="(p,dishIndex) in dishlist" :category="p.category" :categoryIndex="dishIndex" :dishes="p.dishes" :key="p.category.category_id" />
    </div>
    <a id="ratingSection" name="rating"></a>
    <CookSectionRating :rating="data.cook.rating_details" />
    <router-view />

    <PopupComponent :showClose="false" v-if="showPopup" @close="closePopup" variant="center">
        <PopupRendererComponent :url="popupUrl" :content="popupData" @close="closePopup"></PopupRendererComponent>
      </PopupComponent>


    <PopupComponent :showClose="false" v-if="showWizard" @close="closePopup" variant="center">
      <AIWizardPopupComponent
        :showClose="false"
        v-if="showWizard"
        @close="closePopup"
        :url="data.chat.wizard"
        formMethod="POST"
        :userSessionId="wizardUserSessionId"
        :onSubmitHandler="handleWizardSubmit"
        @wizard-loaded="handleWizardLoaded"
      />
    </PopupComponent>
  </LoadingWrapper>
</template>
<script>
import {useRoute} from 'vue-router'
import {fetch3, formSubmit} from '@/modules/configuration.js'
import {addGoogleAnalyticsDataLayer} from '@/modules/configuration.js';
import SectionImageComponent from "@/components/generic/SectionImageComponent.vue";
import RatingComponent from "@/components/generic/RatingComponent.vue";
import DishTypeFilterComponent from "@/components/DishTypeFilterComponent.vue";
import CategoryAndDishesComponent from "@/components/CategoryAndDishesComponent.vue";
// import DishFilterComponent from "@/components/DishFilterComponent.vue";
import CookSectionRating from "@/components/CookSectionRating.vue";
import LikeComponent from "@/components/generic/LikeComponent.vue";
import CookHeadComponent from "@/components/CookHeadComponent.vue";
// import HorizontalScrollContainer from "@/components/generic/HorizontalScrollContainer.vue";
import ReadMore from "@/components/generic/ReadMore.vue";
import LoadingWrapper from '@/components/LoadingWrapper.vue'
import CookAttributesComponent from '@/components/cook/CookAttributesComponent.vue'
import FloatingBarComponent from "@/components/search/FloatingBarComponent.vue"
import FormFilterTagsComponent from "@/components/form/FormFilterTagsComponent.vue";
import StickyElement from "@/components/generic/StickyElement.vue";
import CookChoiceBadgeComponent from "@/components/BadgeComponent.vue";
// import WizardPopupComponent from '@/components/search/WizardPopupComponent.vue';
import PopupRendererComponent from '@/components/popup/PopupRendererComponent.vue';
import PopupComponent from '@/components/PopupComponent.vue';
import AIWizardPopupComponent from '@/components/popup/AIWizardPopupComponent.vue';
import { chatService } from '@/services/chatService';
import { logger } from '@/utils/logger';
import YummiExtraComponent from "@/components/YummiExtraComponent.vue";
export default {
  components: {
    SectionImageComponent,
    RatingComponent,
    DishTypeFilterComponent,
    CategoryAndDishesComponent,
    CookSectionRating,
    // DishFilterComponent,
    LikeComponent,
    CookHeadComponent,
    // HorizontalScrollContainer,
    ReadMore,
    LoadingWrapper,
    CookAttributesComponent,
    FloatingBarComponent,
    FormFilterTagsComponent,
    StickyElement,
    CookChoiceBadgeComponent,
    PopupRendererComponent,
    PopupComponent,
    // WizardPopupComponent,
    AIWizardPopupComponent,
    YummiExtraComponent
  },
  data() {
    return {
      loading: true,
      sentimentsFilter: [],
      dishlist: [],
      data: {},
      filterListDisplay: null,
      innerLoading: false,
      floatingBarData: {},
      showPopup: false, // Controls whether the popup is visible
      showWizard: false, // Controls whether the wizard is visible
      wizardData: null, // Data for the WizardComponent
      wsEnabled: false,
      conversationId: null,
      wizardUserSessionId: null,
      chatService: chatService
    }
  },
  mounted() {
    const route = useRoute();
    this.getData('c/' + route.params.cookid, route.hash);
    this.emitter.on("city-selected", () => {
      this.refereshFloatingBar();
    });

  },
  methods: {
    async getData(url, hash) {
      const data = await fetch3(this, {
        url: url,
        addQueryString: true 
      });
      if (Object.keys(data).length ===0) return ;
      
      this.data = data;
      this.dishlist = data.cook.dishes_list;
      this.floatingBarData = data.floating_bar;
      this.filterListDisplay = data.cook.filters_list_display;
      this.loading = false;
      const this$ = this;
      // console.log('hash is: ' + hash);
      if (hash == '#rating') {
        await this.$nextTick();
        window.setTimeout(() => {
          this$.scrollToRating();
        }, 300);
      } else {
        document.body.scrollTop = 0; // For Safari
        document.documentElement.scrollTop = 0; // For Chrome, Firefox, IE and Opera
      }
    },
    async scrollToRating() {
      const el = document.getElementById("ratingSection");
      if (el) {
        const y = el.getBoundingClientRect().top + window.pageYOffset - 70 - 45;
        await this.$nextTick();
        window.scrollTo({top: y, behavior: 'smooth'});
      }
    },
    async addRemoveFilter(prefId) {
      console.log("addRmoverFilter");
      const index = this.sentimentsFilter.indexOf(prefId);
      if (index === -1) {
        this.sentimentsFilter.push(prefId);
      } else {
        this.sentimentsFilter.splice(index, 1);
      }
      this.innerLoading = true;
      const response = await formSubmit(this, null, this.data.cook.filter_dishes.href, {
        [this.data.cook.filter_dishes.data_name]: this.sentimentsFilter.join(",")
      });
      if (response?.dishes_list) {
        // console.log('updated');
        this.dishlist = response.dishes_list;
      }
      let listElm = this.$refs.list;
      listElm.classList.toggle('filter-elm-' + prefId);
      listElm.classList.toggle('filter', listElm.className.indexOf('filter-elm-') > 0);
      this.innerLoading = false;
    },
    preferencesList(prefs) {
      return prefs.join(" | ");
    },
    openPopup(content) {
      // this.showWizard = true
      this.$store.dispatch('showPopup', content);
    },
    async submitFilter() {
      this.innerLoading = true;
      let form = this.$refs.form;
      const response = await formSubmit(this, form);
      this.dishlist = response.dishes_list;
      this.filterListDisplay = response.filters_list_display;
      // console.log(response);
      this.innerLoading = false;
      this.$nextTick(() => {
        const customDataLayer = response.data_layer;
        addGoogleAnalyticsDataLayer(customDataLayer);
      });

    },
    async refereshFloatingBar() {
      const data = await fetch3(this, {
        url: this.floatingBarData.update_url,
        method: "post",
        addQueryString: true
      });
      this.floatingBarData = data.floating_bar;

    },
    async callChat(href) {
      await fetch3(this, {
        url: href,
        method: "post",
      });
    },
    async openWizard() {
      try {
        this.showWizard = true;
      } catch (error) {
        logger.error("Failed to open wizard:", error);
      }
    },
    handleWizardLoaded(userSessionId) {
      if (userSessionId) {
        this.wizardUserSessionId = userSessionId;
      }
    },
    registerWebSocket(userSessionId) {
      return new Promise((resolve, reject) => {
        try {
          this.chatService.connect();
          this.chatService.subscribe({
            onConnected: () => { this.wsEnabled = true; resolve(); },
            onDisconnected: () => {
              logger.log('WebSocket disconnected');
              this.wsEnabled = false;
            },
            onChatStarted: () => {
              logger.log('Chat started');
            },
            onChatCompleted: (data) => {
              logger.log('Chat completed:', data);
              this.handleChatResponse(data);
            },
            onError: (error) => {
              logger.error('WebSocket error:', error);
              this.handleError(error);
            },
            onReceived: (data) => {
              logger.log('Received message:', data);
              this.handleChatResponse(data);
            }
          }, userSessionId);
        } catch (error) {
          this.wsEnabled = false;
          this.handleError(error);
          reject(error);
        }
      });
    },
    async handleWizardSubmit(formDataObj) {
      try {
        if (!this.wizardUserSessionId) throw new Error('No user session ID available');
        if (!this.wsEnabled) await this.registerWebSocket(this.wizardUserSessionId);
        this.chatService.processChat(this.wizardUserSessionId, formDataObj)
          .catch(error => { 
            this.showWizard = false;
            this.handleError(error, true);
          });
      } catch (error) {
        this.handleError(error);
      }
    },
    async handleChatResponse(response) {
      logger.log('CookView: handleChatResponse called with:', response);
      if (response.status === 'completed' && response.redirect_url) {
        if (this.wizardUserSessionId) {
          try {
            await this.chatService.disconnect();
            logger.log('CookView: Successfully disconnected chat service');
          } catch (error) {
            logger.error('CookView: Error disconnecting chat service:', error);
          }
        }

        if (!response.keep_open) {
          this.showWizard = false;
        }

        await this.$nextTick();

        if (response.redirect_url.startsWith('/')) {
          this.$router.push(response.redirect_url);
        } else {
          window.location.href = response.redirect_url;
        }
      }
    },
    handleError(error, handled = false) {
      if (handled) return;
      logger.error('Error handling chat:', error);
    },
    closePopup() {
      this.showPopup = false;
      this.showWizard = false;
      // Don't disconnect the WebSocket here
    }
  },
  computed: {
    categoryList() {
      return this.dishlist.map(item => item.category);
    }
  }
}
</script>
<style scoped>
.preferences {
  background: #f3f1f1;
}
.description {
  color: #38383b;
}
.accordion-button::after {
  margin-right: 10px;
}

@media (min-width: 1200px) {
  .header-shadow {
    box-shadow: 0px 0px 20px #00000015;
    border-radius: 17px 0px 0px 17px;
  }
}

.float {
  position: absolute;
  z-index: 1000;
  background-color: white;
  border: 1px solid #ccc;
}

.recycler_container {
  display: flex;
  align-items: center;
}
.recycler_image {
  height: 19px;
  width: 19px;
}

.recycler_text_container {
  margin-right: 5px;
}

.ai_frame {
  position: relative;
  background-color: #ffffff;
  border-style: solid;
  border-width: 3px;
  border-color: red;
  text-align: center;
  margin-left: 15px;
}

.ai_frame::before {
  content: "";
  display: block;
  position: absolute;
  left: -15px;           /* 5px gap + 5px line width */
  top: 0;
  height: 100%;
  width: 5px;
  background: black;
}

@media (max-width: 768px) {
  .ai_frame {
    width: 90px;
  }
}

.ai_frame.disabled {
  opacity: 0.5;
  pointer-events: none;
  cursor: not-allowed;
}
</style>